<script setup lang="ts">
import { AfButtonsFAB } from '@af-lib/ui-lib';
import { ref } from 'vue';

import HubspotSupportForm from './HubspotSupportForm.vue';

const fabButtonElement = ref();
function close() {
  fabButtonElement.value?.close();
}
</script>

<template>
  <AfButtonsFAB ref="fabButtonElement" icon="fas fa-headset" position="left">
    <template #primary-actions>
      <slot name="primary-actions"> <HubspotSupportForm @close="close" /></slot>
    </template>
  </AfButtonsFAB>
</template>

<style scoped lang="scss"></style>
